/**
 * @fileOverview Ensures that all files for a branch are loaded before loading
 * any child components
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { loadSchema } from './../../store/branches/actions'


const mapStateToProps = (state, props) => {

  var branch = state.branches[props.branchId]

  return {
    loading: !branch.schema,
    schema: branch.schema,
  }
}

const mapDispatchToProps = (dispatch, {
  branchId
}) => ({
  loadSchema: () => dispatch(loadSchema(branchId)),
})

const BranchFilesHOC = props => {
  if (!props.schema)
    props.loadSchema()
  if (props.loading) return props.loadingElement || null
  return props.children
}

export default connect(mapStateToProps, mapDispatchToProps)(BranchFilesHOC)



// WEBPACK FOOTER //
// ./src/modules/BranchFilesHOC/BranchFilesHOC.js